import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { ChangeHolidayRequestStatus } from "@interfaces/changeHolidayRequestStatus.interface";
import { Service } from "@services/service";

@Injectable()
export class HolidayRequestService extends Service {
	constructor(injector: Injector) {
		super("HolidayRequest", injector);
	}

	// API
	changeStatus(data: ChangeHolidayRequestStatus) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeStatus`, data);
	}

	dashboard() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Dashboard`);
	}

	holidayPlanner(year: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/HolidayPlanner/${year}`);
	}

	myRequestsForYear(year: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/MyRequestsForYear/${year}`);
	}

	overlappingHolidayRequestsFor(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OverlappingHolidayRequestsFor/${id}`);
	}
}